module.exports = __webpack_public_path__ + "img/rawpixel-id-646437-transparent-490x340.28411084.png";